import { useTranslation } from 'react-i18next'
import cn from 'classnames/bind'
import styles from './index.module.css'
import { HelpDesk as HelpDeskIcon } from '../../../components/svg/HelpDesk'
import { Button } from '../../../components/Button'

const cx = cn.bind(styles)

export const HelpDesk = () => {
  const { t } = useTranslation()

  return (
    <div className={cx('wrapper')}>
      <div className={cx('helpdesk')}>
        <Button
          kind="primary-inverse"
          size="sm"
          onClick={() => (window.location.href = 'mailto:nso-helpdesk@a-cube.io')}
        >
          <HelpDeskIcon width={24} height={24} /> {t('helpDesk.btnLabel')}
        </Button>
      </div>
    </div>
  )
}
